/*
    The div with the id main-window contains 6 buttons when pause/play is not loaded and 8 when its loaded.
    The results of the querySelector("button") will either have 8 or 6 buttons.
    Based on my tests, button[2] contains the pause/play mechanism when there are 8 buttons returned, but is yet to be tested on all published formats on storyline.
    It works for flash/html5/AMP formats at this point in time
*/
function triggerPlay() {

    let nodeLength = document.getElementById('qa_films').contentWindow.document.getElementById('main-window').querySelectorAll("button").length;
    console.log(nodeLength)
    if (nodeLength > 6) {
        console.log("Clicked")
        document.getElementById('qa_films').contentWindow.document.getElementById('main-window').querySelectorAll("button")[2].click()
    }
}

export default triggerPlay;

